<div class="add-eoi">
    <div class="page">
        <div class="dialog-title flex justify-between">
            <div class="flex align-center">
                <div class="title">Express of Interest</div>
                <img (click)="openForm()" src="./assets/images/black/download.png" class="down-img"> 
            </div>
            <button mat-icon-button  (click)="close()">
                <mat-icon style="color: #DEDEDE;">close</mat-icon>
            </button>
        </div>

        <!-- <div class="info" *ngIf="fileName">
            <p>Please download and complete the&nbsp;</p>
            <p class="eoi-form" (click)="openForm()">EOI Form</p>
            <mat-icon style="font-size: 22px;color:#556EE6;cursor: pointer;" (click)="openForm()">launch</mat-icon>
            <p>&nbsp;before start the express of interest. </p>
        </div> -->

        <div style="border-bottom: 0.5px solid rgba(222, 222, 222, 0.2);">
            <div style="margin: 48px 32px 24px;">
                <div style="font-size: 21px;line-height: 25px;font-weight: 400;">Details</div>
                <div class="mt_20 container">
                    <mat-grid-list cols="6" rowHeight="37px" gutterSize="15px">
                        <mat-grid-tile colspan="2">
                            <input placeholder="First Name" class="input" id="first" [(ngModel)]="firstName">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="2">
                            <input placeholder="Middle Name" class="input" id="middle" [(ngModel)]="middleName">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="2">
                            <input placeholder="Last Name" class="input" id="last" [(ngModel)]="lastName">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="3">
                            <input placeholder="Email" class="input" id="email" [(ngModel)]="email">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="3">
                            <input placeholder="Mobile" class="input" id="mobile" [(ngModel)]="mobile">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="6">
                            <input placeholder="Address Line" class="input" id="address" [(ngModel)]="addressLine">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="2">
                            <input placeholder="State" class="input" id="state" [(ngModel)]="state">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="2">
                            <input placeholder="Country" class="input" id="country" [(ngModel)]="country">
                        </mat-grid-tile>
                        <mat-grid-tile colspan="2">
                            <input placeholder="Postcode" class="input" id="postcode" [(ngModel)]="postcode">
                        </mat-grid-tile>
                    </mat-grid-list>
                    <!-- <form [formGroup]="" style="display: flex; flex-direction: column">
                        <div style="display: flex; justify-content: space-between">
                            <mat-form-field appearance="outline" style="width: 30%">
                                <mat-label>First name</mat-label>
                                <input matInput formControlName="firstName">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width: 30%">
                                <mat-label>Middle Name</mat-label>
                                <input matInput formControlName="middleName">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width: 30%">
                                <mat-label>Last name</mat-label>
                                <input matInput formControlName="lastName">
                            </mat-form-field>
                        </div>
                        <div style="display: flex; justify-content: space-between">
                            <mat-form-field appearance="outline" style="width: 45%">
                                <mat-label>Email</mat-label>
                                <input matInput formControlName="email">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width: 45%">
                                <mat-label>Mobile</mat-label>
                                <input matInput formControlName="mobile">
                            </mat-form-field>
                        </div>
                        <div style="display: flex; justify-content: space-between">
                            <mat-form-field appearance="outline" style="width: 100%">
                                <mat-label>Address Line</mat-label>
                                <input matInput formControlName="addressLine">
                            </mat-form-field>
                        </div>
                        <div style="display: flex; justify-content: space-between">
                            <mat-form-field appearance="outline" style="width: 30%">
                                <mat-label>State</mat-label>
                                <input matInput formControlName="state">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width: 30%">
                                <mat-label>Country</mat-label>
                                <input matInput formControlName="country">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width: 30%">
                                <mat-label>Postcode</mat-label>
                                <input matInput formControlName="postcode">
                            </mat-form-field>
                        </div>
                    </form> -->
                </div>
            </div>
        </div>

        <div style="padding: 32px;">
            <div class="flex justify-between">
                <div style="width: 100%;">
                    <div>Upload your EOI form</div>
                    <div class="drag-drop" style="width: 90%;">
                        <ngx-file-drop accept=".pdf" dropZoneLabel="Drop files here" [showBrowseBtn]=true
                            (onFileDrop)="dropped($event)" (onFileOver)="fileOver($event)"
                            (onFileLeave)="fileLeave($event)">
                            <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                <div class="upload-grid" (click)="openFileSelector()">
                                    <!-- <mat-icon style="width:30px;height:20px;">cloud_upload</mat-icon>

                                    <div class="txt">Choose a file or drag it here</div>
                                    <div class="text">Maximum file size is 10 MB Maximum number of files is 3</div> -->
                                    <div>
                                        <!-- <mat-icon style="width:30px;height:20px;">cloud_upload</mat-icon> -->
                                        <img src="./assets/images/black/upload.png"
                                            style="width: 38px;height:37px;margin-right:5px;">
                                    </div>
                                    <div>
                                        <div class="txt"><span
                                                style="text-decoration-line: underline;color: #2144ff;cursor: pointer;">Choose
                                                a file</span> or drag it here</div>
                                        <!-- <div class="text">Maximum file size is 10 MB Maximum number of files is 3</div> -->
                                        <div class="text">The file size is less than 30MB.</div>
                                    </div>
                                </div>
                            </ng-template>
                        </ngx-file-drop>
                        <div *ngIf="invalidFileType" style="margin-top: 4px; font-size: 14px; color: #dc3545">
                            {{lang === 'en' ? 'The file should be less than 40M and maximum 3 files' :
                            '文件大小不能超过40M且最多3个文件'}}
                        </div>
                        <div *ngIf="isRequired" style="margin-top: 4px; font-size: 14px; color: #dc3545">
                            {{lang === 'en' ? 'This is required' : '此项为必填项'}}
                        </div>
                        <!--                    <div *ngIf="contractFiles && contractFiles.length > 0" style="margin-top: 0.75rem">-->
                        <!--                        <div *ngFor="let f of contractFiles" class="file">-->
                        <!--                            <div style="cursor: pointer">{{ f.name }}</div>-->
                        <!--                            <mat-icon style="color: #dc3545; margin-left: 100px; cursor: pointer"-->
                        <!--                                      (click)="removeFile(f)">delete-->
                        <!--                            </mat-icon>-->
                        <!--                        </div>-->
                        <!--                    </div>-->
                        <!--                    新样式-->
                        <div class="files_list">
                            <div class="single_file" *ngFor="let file of contractFiles;let i = index">
                                <img src="./assets/images/pdf-file.svg" alt="file" width="45px">
                                <div class="info" fxLayout="column" fxLayoutAlign="space-between" fxLayoutGap="10px">
                                    <div fxLayout="row" fxLayoutAlign="space-between">
                                        <h4 class="name">
                                            {{ file?.name }}
                                        </h4>
                                        <div *ngIf="file.progress === 100" fxLayout="row" fxLayoutAlign="center center"
                                            fxLayoutGap="10px">
                                            <img src="./assets/images/black/del.png" width="19px" height="22px"
                                                alt="file" (click)="removeFile(file)" />
                                        </div>
                                    </div>
                                    <p class="size" *ngIf="file.progress === 100">
                                        {{ currentTime | date: 'HH:mm:ss yyyy-MM-dd' }}
                                    </p>
                                    <app-progress *ngIf="file.progress !== 100" [progress]="file?.progress"
                                        (cancelUpload)="removeFile(file)"></app-progress>
                                </div>
                            </div>
                        </div>
                        <!--                    新样式-->
                    </div>
                </div>
                <div style="width:100%;">
                    <div>Payment Reciept</div>
                    <div style="width: 90%;">
                        <div class="drag-drop">
                            <ngx-file-drop accept=".pdf, .png, .jpg, .jpeg" dropZoneLabel="Drop files here"
                                [showBrowseBtn]=true (onFileDrop)="droppedReciept($event)"
                                (onFileOver)="fileOverReciept($event)" (onFileLeave)="fileLeaveReciept($event)">
                                <ng-template ngx-file-drop-content-tmp let-openFileSelectorReciept="openFileSelector">
                                    <div class="upload-grid" (click)="openFileSelectorReciept()">
                                        <div>
                                            <!-- <mat-icon style="width:30px;height:20px;">cloud_upload</mat-icon> -->
                                            <img src="./assets/images/black/upload.png"
                                                style="width: 38px;height:37px;margin-right:5px;">
                                        </div>
                                        <div>
                                            <div class="txt"><span
                                                    style="text-decoration-line: underline;color: #2144ff;cursor: pointer;">Choose
                                                    a file </span> or drag it here</div>
                                            <!-- <div class="text">Maximum file size is 10 MB Maximum number of files is 3</div>     -->
                                            <div class="text">The file size is less than 30MB.</div>
                                        </div>
                                        <!-- <mat-icon style="width:30px;height:20px;">cloud_upload</mat-icon>

                                        <div class="txt">Choose a file or drag it here</div>
                                        <div class="text">Maximum file size is 10 MB Maximum number of files is 3</div> -->

                                    </div>
                                </ng-template>
                            </ngx-file-drop>
                            <div *ngIf="invalidFileRecieptType"
                                style="margin-top: 4px; font-size: 14px; color: #dc3545">
                                {{lang === 'en' ? 'The file should be less than 40M and maximum 3 files' :
                                '文件大小不能超过40M且最多3个文件'}}
                            </div>
                            <!--                    <div *ngIf="contractRecieptFiles && contractRecieptFiles.length > 0" style="margin-top: 0.75rem">-->
                            <!--                        <div *ngFor="let f of contractRecieptFiles" class="file">-->
                            <!--                            <div style="cursor: pointer">{{ f.name }}</div>-->
                            <!--                            <mat-icon style="color: #dc3545; margin-left: 100px; cursor: pointer"-->
                            <!--                                      (click)="removeRecieptFile(f)">delete-->
                            <!--                            </mat-icon>-->
                            <!--                        </div>-->
                            <!--                    </div>-->
                            <div class="files_list">
                                <div class="single_file" *ngFor="let file of contractRecieptFiles;let i = index">
                                    <img src="./assets/images/pdf-file.svg" alt="file" width="45px">
                                    <div class="info" fxLayout="column" fxLayoutAlign="space-between"
                                        fxLayoutGap="10px">
                                        <div fxLayout="row" fxLayoutAlign="space-between">
                                            <h4 class="name">
                                                {{ file?.name }}
                                            </h4>
                                            <div *ngIf="file.progress === 100" fxLayout="row"
                                                fxLayoutAlign="center center" fxLayoutGap="10px">
                                                <img src="./assets/images/black/del.png" width="19px" height="px"
                                                    alt="file" (click)="removeRecieptFile(file)" />
                                            </div>
                                        </div>
                                        <p class="size" *ngIf="file.progress === 100">
                                            {{ currentTime | date: 'HH:mm:ss yyyy-MM-dd' }}
                                        </p>
                                        <app-progress *ngIf="file.progress !== 100" [progress]="file?.progress"
                                            (cancelUpload)="removeRecieptFile(file)"></app-progress>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button mat-flat-button
                style="background: #161616;color: #DEDEDE; border: 1px solid #DEDEDE;border-radius: 8px;width: 100%;"
                (click)="submit()">Create and Approve
            </button>
        </div>
    </div>

    <!-- <div style="display: flex;justify-content: end;">
        <button mat-flat-button style="margin-right: 20px;background: rgba(53, 41, 66, 0.1);color: #352942"
                (click)="back(false)">Back
        </button>
        <button mat-flat-button style="background: #161616;color: #DEDEDE; border: 1px solid #DEDEDE;border-radius: 8px;width: 100%;"
                (click)="submit()">Create and Approve
        </button>
    </div> -->
</div>